import React, { useEffect, useState } from "react";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import moment from "moment";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  saveUserDetails,
} from "../../store/actions/UserActions";
import MainHeading from "../../components/comman/MainHeading";
import DashboardEventCard from "../../components/comman/DashboardEventCard";
import AttendanceDashboard from "./DashboardDataListingComponents/AttendanceDashboard";
import PendingPaymentTicketsTabWise from "./DashboardDataListingComponents/PendingPaymentTicketsTabWise";
import PendingSalaryTickets from "./DashboardDataListingComponents/PendingSalaryTickets";
import PendingPurchaseRequests from "./DashboardDataListingComponents/PendingPurchaseRequests";
import PaymentOverviewSummery from "./DashboardDataListingComponents/PaymentOverviewSummery";
import PendingPurchaseOrders from "./DashboardDataListingComponents/PendingPurchaseOrders";
import PendingInvoice from "./DashboardDataListingComponents/PendingInvoice";
import PendingGRN from "./DashboardDataListingComponents/PendingGRN";
import PendingStockout from "./DashboardDataListingComponents/PendingStockout";
import PendingLeaveRequests from "./DashboardDataListingComponents/PendingLeaveRequests";
import CommonDonutChart from "../../components/comman/Charts/CommonDonutChart";
import TodayAttendance from "./DashboardDataListingComponents/TodayAttendance";
import ManPowerChart from "../../components/comman/Charts/ManpowerChart";
import BgBlurLoader from "../../components/Loaders/BgBlurLoader";
import LiveClock from "../../components/comman/LiveClock";
import {
  calculateHours,
  convertTime,
  formatTo12HourTime,
  getCurrentLocation,
  isWithinRadius,
  withInShift,
  getMonthStartEnd,
} from "../../utility/CommonFunctions";
import CheckInIcon from "../../components/Icons/CheckInIcon";
import CheckOutIcon from "../../components/Icons/CheckOutIcon";
import TotalHoursIcon from "../../components/Icons/TotalHoursIcon";
import { Spinner } from "reactstrap";

export default function UserDashboard() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.root.userDetails);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [pageLoading, setPageLoading] = useState(true);
  const [state, setState] = useState({
    leavesData: {},
    ArData: {},
    OdData: {},
    checkInTime: null,
    checkOutTime: null,
    attendanceId: null,
    isODrequest: null,
  });

  const [pageStates, setPageStates] = useState({
    dashboardData: [],
    birthday_list: [],
    anniversaryList: [],
    sortByDate: [
      moment().subtract(30, "days").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
  });

  const [disable, setDisabled] = useState(false);
  const [currentTime, setCurrentTime] = useState(moment());
  const isWithinShift = userDetails ? withInShift(userDetails, currentTime)?.isWithin : false;

  const [loading, setLoading] = useState({
    requestLoading: false,
    MarkAttendanceLoading: false,
    extarWorkLoading: false,
    isLoading: false,
  });

  useEffect(() => {
    initDashboard();
  }, []);

  useEffect(() => {
    if (isWithinShift) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [isWithinShift]);

  const initDashboard = async () => {
    try {
      await GetEmployeeDetail();
      // After profile is loaded, fetch these essential counts in parallel
      await Promise.all([
        GetBirthday_Anniversary_Data(),
        getLeaveCount(),
        getCheckIn(),
      ]);
    } catch (error) {
      console.error("Dashboard initialization error:", error);
    } finally {
      // Finally show the dashboard, which triggers child component APIs
      setPageLoading(false);
    }
  };

  const GetEmployeeDetail = async () => {
    let options = {
      method: "GET",
    };
    setLoading((pre) => ({
      ...pre,
      isLoading: true,
    }));
    let API = apiUrl?.get_profile;
    const response = await callApi(API, options);
    setLoading((pre) => ({
      ...pre,
      isLoading: false,
    }));
    if (response?.status === true) {
      dispatch(saveUserDetails(response?.data));
    } else {
      toast.error(response?.message);
    }
  };

  const GetBirthday_Anniversary_Data = async () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_birthday_anniversary;
    const response = await callApi(API, options);
    if (response?.status === true) {
      setPageStates((prev) => ({
        ...prev,
        birthday_list: response?.data?.employeesBirthday,
        anniversaryList: response?.data?.employeesWorkAnniversary,
      }));
    }
  };

  const getLeaveCount = async (type) => {
    const option = {
      method: "GET",
    };
    const url = apiUrl.get_leave_count + `?type=fromDashboard`;
    const res = await callApi(url, option);
    if (res?.status === true) {
      setState((pre) => ({
        ...pre,
        leavesData: res?.data?.leave,
        ArData: res?.data?.arRequest,
        OdData: res?.data?.odRequest,
      }));
    } else {
      toast.error(res?.message);
    }
  };

  const getCheckIn = (type, date = null) => {
    let options = {
      method: "GET",
    };
    const startDateEndDate = {
      startDate: getMonthStartEnd(new Date()).start.toDateString(),
      endDate: getMonthStartEnd(new Date()).end.toDateString()
    }
    let endPoint;
    if (type === "myAttendance") {
      endPoint = apiUrl.get_attendance + `?myAttendance=true&startDate=${date?.startDate ? date?.startDate : startDateEndDate.startDate}&endDate=${date?.endDate ? date?.endDate : startDateEndDate.endDate}&pageSize=31`
    } else if (type === "overTime") {
      endPoint = apiUrl.get_extra_work + `?myExtraWork=true`
    } else {
      endPoint = apiUrl.get_attendance + `?todayAttendance=true`
    }
    callApi(endPoint, options).then((res) => {
      if (res?.status === true) {
        if (type === "myAttendance") {
          setState((pre) => ({
            ...pre,
            present: res?.data?.attendance?.filter((item) => item?.status === 1),
            arRequest: res?.data?.attendance?.filter((item) => item?.status === 1 && item?.arRequestStatus === 1),
            odRequest: res?.data?.attendance?.filter((item) => item?.status === 1 && item?.odRequestStatus === 1),
            absent: res?.data?.attendance?.filter((item) => item?.status === 0),
            leave: res?.data?.attendance?.filter((item) => item?.status === 3),
            pending: res?.data?.attendance?.filter((item) => item?.status === 2),
            data: res?.data?.attendance
          }));
        } else if (type === "overTime") {
          setState((pre) => ({
            ...pre,
            extraInTime: res?.data?.extraWork?.length > 0 ? res?.data?.extraWork[0]?.startDate : null,
            extraOutTime: res?.data?.extraWork?.length > 0 ? res?.data?.extraWork[0]?.endDate : null,
          }));
        } else {
          const todayRecord = res?.data?.attendance?.length > 0 && res?.data?.attendance[0]?.attendances?.length > 0
            ? res?.data?.attendance[0]?.attendances[0]
            : null;
          setState((pre) => ({
            ...pre,
            checkInTime: todayRecord ? todayRecord.checkInTime : null,
            checkOutTime: todayRecord ? todayRecord.checkOutTime : null,
            attendanceId: todayRecord ? todayRecord.id : null,
            isODrequest: todayRecord ? todayRecord.isODrequest : null
          }));
          if (todayRecord?.checkInTime && todayRecord?.checkOutTime) {
            setDisabled(true);
            return;
          }
        }
      } else {
        toast.error(res?.message)
      }
    })
  }

  const handleCheckIn = async (type) => {
    setLoading((pre) => ({
      ...pre,
      MarkAttendanceLoading: true
    }));

    try {
      // Check if within shift first (quick response)
      if (!isWithinShift) {
        toast.error("You are not within your shift time");
        setLoading((pre) => ({
          ...pre,
          MarkAttendanceLoading: false
        }));
        return;
      }

      // Get current location and validate radius
      const location = await getCurrentLocation();
      const isInRadius = location?.status ? isWithinRadius(
        location.latitude,
        location.longitude,
        +userDetails?.office?.location?.lat,
        +userDetails?.office?.location?.lng,
        +userDetails?.office?.range
      ) : true

      if (!isInRadius) {
        toast.error("You are not within the office range");
        setLoading((pre) => ({
          ...pre,
          MarkAttendanceLoading: false
        }));
        return;
      }

      if (state?.checkInTime && state?.checkOutTime) {
        setDisabled(true);
        setLoading((pre) => ({
          ...pre,
          MarkAttendanceLoading: false
        }));
        return;
      }

      const postData = {
        ...(!state?.checkInTime && { checkInTime: convertTime() }),
        ...(state?.checkInTime && { checkOutTime: convertTime() }),
        ...(state?.checkInTime && { attendanceId: state?.attendanceId }),
      }
      let options = {
        method: "POST",
        data: postData
      };
      const url = apiUrl.mark_attendance
      const res = await callApi(url, options);
      if (res?.status === true) {
        toast.success(res?.message);
        getCheckIn();
      } else {
        toast.error(res?.message)
      }
    } catch (err) {
      console.log("err", err?.message);
    } finally {
      setLoading((pre) => ({
        ...pre,
        MarkAttendanceLoading: false
      }));
    }
  }

  const handleShiftStatusChange = (status) => {
    setDisabled(status);
  };

  const department = userDetails?.department?.name;
  const isHRM = department === "HRM" || department === "Management";
  const isAccount = department === "Account" || department === "Management";
  const isSCM = department === "SCM" || department === "Management";
  const isSolarWind = department === "Solar / Wind" || department === "Management";
  const isGSS = department === "GSS / TL" || department === "Management";
  const canAccessTeam = userDetails?.designation?.canAccessTeam;

  if (pageLoading) {
    return <BgBlurLoader />;
  }

  return (
    <>
      <div className="content">
        <MainHeading
          title="Dashboard"
          sites={userDetails?.usersites?.map((item) => ({
            value: item?.site?.id,
            label: item?.site?.name,
          }))}
          office={[]}
          setPageStates={setPageStates}
        />
        <div className="row dash-cards row-gap-3">
          {userDetails?.type === 1 ? (
            <div className="col-12 col-lg-3">
              <div className="card check-in h-100 m-0">
                <div className="card-body h-100">
                  <LiveClock onShiftStatusChange={handleShiftStatusChange} />

                  <div className="d-flex w-100 justify-content-between align-items-center pt-4">
                    <div className="d-flex flex-column justify-content-center align-items-center time-data">
                      <CheckInIcon />
                      <p>{state?.checkInTime ? formatTo12HourTime(state?.checkInTime) : "00:00"}</p>
                      <span>Check In</span>
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-center time-data">
                      <CheckOutIcon />
                      <p>{state?.checkOutTime ? formatTo12HourTime(state?.checkOutTime) : "00:00"}</p>
                      <span>Check Out</span>
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-center time-data">
                      <TotalHoursIcon />
                      <p>{calculateHours(state?.checkInTime, state?.checkOutTime)}</p>
                      <span>Total Hours</span>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => handleCheckIn()}
                    disabled={(state?.checkInTime && state?.checkOutTime) || !disable}
                    className="btn btn-primary w-100 mt-3"
                  >
                    {loading.MarkAttendanceLoading ? (
                      <Spinner />
                    ) : state?.checkInTime && state?.checkOutTime ? (
                      "Marked for today"
                    ) : !state?.checkInTime && !state?.checkOutTime ? (
                      "Check In"
                    ) : (
                      "Check Out"
                    )}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <TodayAttendance />
          )}
          <CommonDonutChart
            data={state?.leavesData}
            heading={"Leave"}
            colors={["#00C853", "#FFD54F", "#BCAAA4"]}
          />
          <CommonDonutChart
            data={state?.ArData}
            heading={"AR"}
            colors={["#BA68C8", "#F06292", "#7986CB"]}
          />
          <CommonDonutChart
            data={state?.OdData}
            heading={"OD"}
            colors={["#E57373", "#FFB74D", "#BDBDBD"]}
          />
          {/* Manpower Chart==========> */}
          <div className="col-12 col-lg-8">
            <div className="card">
              <div className="card-body">
                <div className="card-head">
                  <h3 className="card-title">Manpower Distribution</h3>
                </div>
                <ManPowerChart />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-4">
            <div className="row">
              <DashboardEventCard
                title={"Birthday"}
                birthdayList={pageStates?.birthday_list}
              />
              <DashboardEventCard
                title={"Work Anniversary"}
                workList={pageStates?.anniversaryList}
              />
            </div>
          </div>

          {(isHRM || isSolarWind || isGSS) && (
            <AttendanceDashboard siteId={filterDetails?.siteId} />
          )}

          {canAccessTeam && (
            <PendingLeaveRequests siteId={filterDetails?.siteId} />
          )}

          {(isHRM || isAccount || isSCM || isSolarWind || isGSS) && (
            <PendingPaymentTicketsTabWise siteId={filterDetails?.siteId} />
          )}

          {(isSCM || isSolarWind || isGSS) && (
            <PendingPurchaseRequests siteId={filterDetails?.siteId} />
          )}

          {isAccount && (
            <PaymentOverviewSummery siteId={filterDetails?.siteId} />
          )}

          {(isHRM || isAccount) && (
            <PendingSalaryTickets siteId={filterDetails?.siteId} />
          )}

          {isAccount && (
            <PendingPurchaseOrders siteId={filterDetails?.siteId} />
          )}

          {isAccount && <PendingInvoice siteId={filterDetails?.siteId} />}

          {(isSCM || isSolarWind || isGSS) && (
            <PendingGRN siteId={filterDetails?.siteId} />
          )}

          {(isSCM || isSolarWind || isGSS) && (
            <PendingStockout siteId={filterDetails?.siteId} />
          )}
        </div>
      </div>
    </>
  );
}
